import css from 'styled-jsx/css';

export default css`
  .posts-wrapper {
    width: 100%;
  }
  .divider {
    width: 100%;
    height: 1px;
    background-color: #a41c1c;
    margin: 20px 0;
  }
  @media (max-width: 575px) {
    .divider {
      background-color: transparent;
      margin: 0;
    }
  }
`;
